<template>
  <validation-observer ref="requestServiceApproveForm" v-slot="{}" tag="form">
    <div class="row">
      <div class="col-12 mb-1">
        <label class="color-gray-7 font-16 font-weight-bold">
          <i class="fas fa-check color-green mr-1" />
          Razón de Aprobación:
        </label>
      </div>
      <div class="col-12 col-md-4" :class="isReadOnly ? 'column-left' : ''">
        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          name="approvalReason"
          rules="required"
        >
          <custom-drop-down
            v-model="reasonSelected"
            custom-error-msg="La razón es requerida."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Razón:"
            :options="reasons"
            placeholder="Seleccione"
          />
        </validation-provider>
        <div v-else>
          <p class="data-title mb-0 title">Razón:</p>
          <p class="font-weight-normal description">
            {{ determination.reasonDescription }}
          </p>
        </div>
      </div>
      <div v-if="showCompensatoryServiceCount" class="col-12 col-md-3">
        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          name="compensatoryAcademicYear"
          rules="required"
        >
          <custom-drop-down
            v-model="selectedCompensatoryAcademicYear"
            custom-error-msg="El año es requerido."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Año Académico:"
            :options="academicYears"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div v-if="showCompensatoryServiceCount" class="col-12 col-md-3">
        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          name="compensatoryMinutesDate"
          rules="required"
        >
          <label class="data-title mb-1">Fecha de Minuta:</label>
          <custom-date-picker
            v-model="model.compensatoryMinutesDate"
            :class-container="'w-100'"
            :custom-error-msg="'La fecha de minuta es requerida.'"
            :error="errors[0]"
            format="dd/MMM./yyyy"
          />
        </validation-provider>
      </div>
      <div v-if="showCompensatoryServiceCount" class="col-12 col-md-2">
        <label class="data-title mb-1">Cantidad de Servicios:</label>
        <br />
        <span>{{ compensatoryMaxVisitCount }}</span>
      </div>
      <div v-if="showServiceApprovalJugdeName" class="col-12 col-md-4">
        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          name="approvalJudgeName"
          rules="required"
        >
          <label class="data-title mb-0">Nombre del Juez:</label>
          <custom-input
            v-model="model.judgeName"
            custom-error-msg="El nombre del juez es requerido."
            :error="errors[0]"
          />
        </validation-provider>
      </div>
      <div v-if="determination.judgeName">
        <p class="data-title mb-0 title">Nombre del Juez:</p>
        <p class="font-weight-normal description">
          {{ determination.judgeName }}
        </p>
      </div>
      <div
        v-if="determination.compensatoryAcademicYear"
        class="col col-sm col-12"
      >
        <p class="data-title mb-0 title">Año Académico:</p>
        <p class="font-weight-normal description">
          {{ determination.compensatoryAcademicYear }}
        </p>
      </div>
      <div
        v-if="determination.compensatoryMinutesDate"
        class="col col-sm col-12"
      >
        <p class="data-title mb-0 title">Fecha de Minuta:</p>
        <p class="font-weight-normal description">
          {{ determination.compensatoryMinutesDate | date('DD/MM/YYYY') }}
        </p>
      </div>
      <div
        v-if="
          determination.compensatoryServiceCount ||
            determination.compensatoryServiceCount === 0
        "
        class="col col-sm col-12"
      >
        <p class="data-title mb-0 title">Cantidad de Servicios:</p>
        <p class="font-weight-normal description">
          {{ determination.compensatoryServiceCount }}
        </p>
      </div>
      <div v-if="showServiceApprovalComment" class="col-12 mt-3">
        <validation-provider
          v-if="!isReadOnly"
          v-slot="{ errors }"
          name="approvalComment"
          rules="required"
        >
          <label class="data-title mb-0">Comentario:</label>
          <custom-text-area
            v-model="model.description"
            :count-classes="['float-right']"
            custom-error-msg="El comentario es requerido."
            :error="errors[0]"
            :maxlength="3000"
            show-char-count
          />
        </validation-provider>
      </div>
      <div v-if="determination.description" class="col-12">
        <p class="data-title mb-0 title">Comentario:</p>
        <p class="font-weight-normal description">
          {{ determination.description }}
        </p>
      </div>
      <div v-if="!isReadOnly" class="col-12 mt-3">
        <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
          <div class="bd-highlight ml-2">
            <action-button
              i="fas  fa-save fa-lg"
              text="Guardar"
              variant="success"
              @click="saveApproval"
            />
          </div>
          <div class="mx-0 bd-highlight">
            <action-button
              id="modal-btn-cancelar"
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger"
              @click="$emit('cancel')"
            />
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import ServiceStatuses from '@/utils/constants/requestServiceStatuses';
import DeterminationReasons from '@/utils/constants/determinationReasons';
import admissionStatus from '@/utils/constants/admissionStatus';

import {
  saveDetermination,
  getDeterminationRequestService,
  getAdmissionByRequestServiceId,
} from '@/services/uspqrp/provisional-remedy.api';

export default {
  name: 'RequestServiceApproval',
  components: {
    CustomDropDown,
    CustomTextArea,
    CustomInput,
    CustomDatePicker,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    academicYears: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {
        judgeName: null,
        description: null,
        compensatoryMinutesDate: null,
      },
      selectedCompensatoryAcademicYear: null,
      reasonSelected: null,
      determination: {
        requestServiceId: null,
        serviceStatusDescription: null,
        reasonDescription: null,
        judgeName: null,
        description: null,
        objection: null,
        rpRequestServiceDeterminationDocumentId: null,
      },
      admission: null,
    };
  },
  computed: {
    compensatoryMaxVisitCount() {
      return this.showCompensatoryServiceCount
        ? this.data.compensatoryMaxVisitCount ?? 0
        : null;
    },
    showServiceApprovalJugdeName() {
      return (
        this.reasonSelected?.id === DeterminationReasons.ApprovedByJudgeOrder
      );
    },
    showCompensatoryServiceCount() {
      return (
        this.reasonSelected?.id ===
        DeterminationReasons.ApprovedByCompensatoryServices
      );
    },
    showServiceApprovalComment() {
      if (!this.reasonSelected) return false;
      return [
        DeterminationReasons.ApprovedByUnitDirector,
        DeterminationReasons.ApprovedByGeneral,
        DeterminationReasons.ApprovedByCompensatoryServices,
        DeterminationReasons.ApprovedByReconsideration,
      ].includes(this.reasonSelected.id);
    },
    reasons() {
      const hasPermissionApprovedByUnitDirector = this.userHasPermissions(
        'menu.rempro.view.reasonforapprovedbyunitdirector'
      );
      const hasPermissionGeneralApprovalReason = this.userHasPermissions(
        'menu.rempro.view.generalapprovalreason'
      );

      let excludedItems = [];

      if (!hasPermissionApprovedByUnitDirector)
        excludedItems.push(DeterminationReasons.ApprovedByUnitDirector);

      if (!hasPermissionGeneralApprovalReason)
        excludedItems.push(DeterminationReasons.ApprovedByGeneral);

      return this.data.reasons.filter((x) => !excludedItems.includes(x.id));
    },
  },
  mounted() {
    if (this.isReadOnly) {
      this.getDeterminationRequestService();
    } else {
      this.getAdmissionByRequestServiceId();
    }
  },
  methods: {
    async saveApproval() {
      const isFormValid = await this.$refs.requestServiceApproveForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información de aprobación solicitada.',
          'error'
        );
        return;
      }

      // Validating any active admission and confirming it's cancelation in SAEE
      if (
        this.data.isReconsideration &&
        this.data.daysCount >= 30 &&
        this.admission.admissionStatusId &&
        (this.admission.admissionStatusId == admissionStatus.Vinculado ||
          this.admission.admissionStatusId == admissionStatus.Asignado ||
          this.admission.admissionStatusId == admissionStatus.Admitido ||
          this.admission.admissionStatusId ==
            admissionStatus.ServicioRelacionadoActivo)
      ) {
        const activeServiceAnswer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea cancelar el servicio que tiene activo la Secretaria de Educación Especial y aprobarlo en Remedio Provisional?',
          'Sí',
          'No'
        );

        if (!activeServiceAnswer) return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea Aprobar el servicio ${this.data.serviceDiscipline}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = objectToFormData(
        {
          requestServiceId: this.data.requestServiceId,
          serviceStatusId: ServiceStatuses.Approved,
          reasonId: this.reasonSelected.id,
          compensatoryServiceCount: this.compensatoryMaxVisitCount,
          compensatoryAcademicYearId: this.selectedCompensatoryAcademicYear?.id,
          ...this.model,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data } = await saveDetermination(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'El servicio ha sido aprobado exitosamente.',
          'success'
        );

      this.$emit('save', data);
    },
    async getDeterminationRequestService() {
      const { data } = await getDeterminationRequestService(
        this.data.requestServiceId
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data) {
        this.determination = data;
      }
    },
    async getAdmissionByRequestServiceId() {
      const { data } = await getAdmissionByRequestServiceId(
        this.data.requestServiceId
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data) {
        this.admission = data;
      }
    },
  },
  watch: {
    isReadOnly(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDeterminationRequestService();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.column-left {
  max-width: 300px !important;
}
.title {
  font-size: 14px;
}
.description {
  font-size: 16px;
}
</style>
